import { isDefined } from 'remeda';
import { z } from 'zod';

export type User = z.infer<typeof User>;

export const User = z
  .object({
    email: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    isUserActivated: z.boolean().optional(),
    isNewUser: z.boolean().optional(),
    partner: z.string().optional(),
    showPersona: z.boolean().optional(),
    role: z.string().optional(),
    subjectAreas: z.array(z.string().optional()).optional(),
    locale: z.string().optional(),
    daysSinceUserCreated: z.number().optional(),
  })
  .and(
    z.union([
      z
        .object({ rlifeUserId: z.number() })
        .transform((user) => ({ ssoUserId: user.rlifeUserId })),
      z.object({ ssoUserId: z.number() }),
    ]),
  )
  .transform((user) => {
    return {
      partner: isDefined(user.partner) ? user.partner : 'ENG',
      isUserActivated: user.isUserActivated,
      isNewUser: user.isNewUser,
      ssoUserId: user.ssoUserId,
      email: user.email,
      showPersona: user.showPersona,
      role: user.role,
      subjectAreas: user.subjectAreas,
      name:
        isDefined(user.firstName) && isDefined(user.lastName)
          ? `${user.firstName} ${user.lastName}`
          : isDefined(user.firstName)
          ? user.firstName
          : isDefined(user.lastName)
          ? user.lastName
          : 'Isaac Newton',
      locale: user.locale,
      daysSinceUserCreated: user.daysSinceUserCreated,
    };
  });
